import type { DriverAvailabilityStatus } from '@chukua/common';

/** Availability is derived on the server from trips and employment (gitaumoses4/chukua#54); these only name what it computed. */
export const AVAILABILITY_LABELS: Record<DriverAvailabilityStatus, string> = {
  available: 'Available',
  on_trip: 'On trip',
  resting: 'Resting',
  off_duty: 'Off duty',
  suspended: 'Suspended',
};

export const AVAILABILITY_COLORS: Record<DriverAvailabilityStatus, string> = {
  available: 'success',
  on_trip: 'processing',
  resting: 'warning',
  off_duty: 'default',
  suspended: 'error',
};
